import React, { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './authConfig'
import { Toaster } from './components/ui/sonner'
import 'react-day-picker/dist/style.css'
import './index.css'

const App = lazy(() => import('./App.tsx'))
const AuthGate = lazy(() => import('./components/AuthGate'))
const DashboardPage = lazy(() => import('./pages/DashboardPage'))
const ProvidersPage = lazy(() => import('./pages/ProvidersPage'))
const ProviderUpdateEditPage = lazy(() => import('./pages/ProviderUpdateEditPage'))
const UpdateFormPage = lazy(() => import('./pages/UpdateFormPage'))

const msalInstance = new PublicClientApplication(msalConfig)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <Suspense fallback={<div className="p-6 text-sm text-gray-600">Loading...</div>}>
          <Routes>
            <Route
              path="/"
              element={
                <AuthGate>
                  <App />
                </AuthGate>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="providers" element={<ProvidersPage />} />
              <Route path="provider-updates/:id/edit" element={<ProviderUpdateEditPage />} />
            </Route>
            <Route
              path="/auth-preview"
              element={
                <AuthGate autoRedirect={false} showPromptWhenAuthenticated>
                  <div />
                </AuthGate>
              }
            />
            <Route path="/Provider-Update" element={<UpdateFormPage />} />
          </Routes>
        </Suspense>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>,
)
